// Each developer's pair of ngrok tunnels, named from one subdomain so the
// loaders' derivation (gt.js, embed2.js: `<sub>.ngrok.io` → `<sub>api.ngrok.io`)
// lands on their own API: REACT_APP_TUNNEL_SUB=karl-tdc gives
// karl-tdc.ngrok.io for the dev site on :3000 and karl-tdcapi.ngrok.io for
// the API on :4008. There is no shared pair any more (2026-10-28): unset,
// the public URLs fall back to localhost, which works for local test pages
// and nothing a real https storefront can reach.
const TUNNEL_SUB = process.env.REACT_APP_TUNNEL_SUB || "";
if (!TUNNEL_SUB && (process.env.REACT_APP_ENV || "development") === "development") {
    // eslint-disable-next-line no-console
    console.warn("REACT_APP_TUNNEL_SUB is not set: embeds and the pixel snippet point at localhost. Set it to your ngrok pair, e.g. karl-tdc.");
}
const publicApiUrl = TUNNEL_SUB ? `https://${TUNNEL_SUB}api.ngrok.io/api/v1` : "http://localhost:4008/api/v1";
const embedHost = TUNNEL_SUB ? `https://${TUNNEL_SUB}.ngrok.io` : "http://localhost:3000";

const dict: Record<string, Record<string, unknown>> = {
    development: {
        API_URL: "http://localhost:4008/api/v1",
        // The API as a customer's live site reaches it (the Shopify pixel):
        // a store can't call localhost, so local goes through the API's own
        // ngrok tunnel (<sub>api.ngrok.io -> :4008), beside the tag's
        // (<sub>.ngrok.io, EMBED_HOST) — the scripts derive the same host.
        PUBLIC_API_URL: publicApiUrl,
        HOST: "http://localhost:4008",
        STRIPE_PUBLIC_SHARE_KEY:
            "pk_test_51MOliaLMI7kBmoVgOM1XIzZCh7RudEYxFwBoRDHeNBHc8JNTbGMKtsVW4zhjUJOt0ofmZzgErz77cSkJgH9iBzNt00GMkkwPYY",
        EMBED_HOST: embedHost,
        CONTACT_US_EMAIL: "hello@thedesirecompany.com",
        //TURNSTILE_SITE_KEY: '0x4AAAAAADHCaZLGJ-9Wo7vb',
        TURNSTILE_SITE_KEY: "1x00000000000000000000AA",
        // empty key disables PostHog for this environment
        POSTHOG_KEY: "",
        POSTHOG_HOST: "https://us.i.posthog.com",
        // Sites the /docs-sso page may hand a sign-in code back to (local
        // tdc-documentation builds).
        DOCS_ORIGINS: ["http://localhost:4177", "http://localhost:4173", "http://localhost:5173"]
    },
    staging: {
        API_URL: "https://api.staging.thedesirecompany.com/api/v1",
        PUBLIC_API_URL: "https://api.staging.thedesirecompany.com/api/v1",
        HOST: "https://api.staging.thedesirecompany.com",
        STRIPE_PUBLIC_SHARE_KEY:
            "pk_test_51MOliaLMI7kBmoVgOM1XIzZCh7RudEYxFwBoRDHeNBHc8JNTbGMKtsVW4zhjUJOt0ofmZzgErz77cSkJgH9iBzNt00GMkkwPYY",
        EMBED_HOST: "https://shoppers.staging.thedesirecompany.com",
        CONTACT_US_EMAIL: "hello@thedesirecompany.com",
        TURNSTILE_SITE_KEY: "0x4AAAAAADHCaZLGJ-9Wo7vb",
        POSTHOG_KEY: "phc_CKeeXEcQUVyiBEbYeGKHyVRYD5kMtQNK68YzQMUQLBCZ",
        POSTHOG_HOST: "https://us.i.posthog.com",
        DOCS_ORIGINS: ["http://localhost:4177", "http://localhost:4173", "http://localhost:5173"]
    },
    production: {
        API_URL: "https://api.prod.thedesirecompany.com/api/v1",
        PUBLIC_API_URL: "https://api.prod.thedesirecompany.com/api/v1",
        HOST: "https://api.prod.thedesirecompany.com",
        STRIPE_PUBLIC_SHARE_KEY:
            "pk_live_51MOliaLMI7kBmoVgZoKQIxupnqdWAMUzvTifSSKRcH0wQSkcM1sBQkxfzanr1MDTGIRUZOCqXrox7hFlBZlC1IOE00ZwMuQLDP",
        EMBED_HOST: "https://shoppers.thedesirecompany.com",
        CONTACT_US_EMAIL: "hello@thedesirecompany.com",
        TURNSTILE_SITE_KEY: "0x4AAAAAADHCaZLGJ-9Wo7vb",
        POSTHOG_KEY: "phc_CKeeXEcQUVyiBEbYeGKHyVRYD5kMtQNK68YzQMUQLBCZ",
        POSTHOG_HOST: "https://us.i.posthog.com",
        // The internal docs site (tdc-documentation on GitLab Pages).
        DOCS_ORIGINS: ["https://docs.thedesirecompany.com", "https://tdc-documentation-db07cd.gitlab.io"]
    }
};

export default dict[process.env.REACT_APP_ENV || "development"];
